import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const adminToken = localStorage.getItem('admin_token');
    setIsAdmin(!!adminToken);
  }, []);

  const handleAdminLogout = () => {
    localStorage.removeItem('admin_token');
    setIsAdmin(false);
    navigate('/');
  };

  return (
    <nav className="glass fixed top-0 left-0 right-0 z-50 border-b border-white/20" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <h1 className="text-2xl font-heading font-semibold text-primary">Psychotherapy with Anvita</h1>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/workshop/book-journaling" className="flex items-center gap-1.5 text-accent font-semibold hover:text-accent/80 transition-colors" data-testid="nav-workshop">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
              </span>
              Happening Now!
            </Link>
            <Link to="/about" className="text-foreground hover:text-primary transition-colors" data-testid="nav-about">About</Link>
            <Link to="/services" className="text-foreground hover:text-primary transition-colors" data-testid="nav-services">Services</Link>
            <Link to="/contact" className="text-foreground hover:text-primary transition-colors" data-testid="nav-contact">Contact</Link>

            {isAdmin ? (
              <>
                <Link to="/admin" className="text-foreground hover:text-primary transition-colors" data-testid="nav-admin">
                  Admin
                </Link>
                <Button onClick={handleAdminLogout} variant="outline" size="sm" data-testid="logout-button">
                  Logout
                </Button>
              </>
            ) : (
              <div className="flex items-center gap-3">
                <Link to="/discovery" data-testid="nav-discovery">
                  <Button variant="outline" className="rounded-full px-5 border-primary text-primary hover:bg-primary/5">Discovery Call</Button>
                </Link>
                <Link to="/book" data-testid="nav-book-session">
                  <Button className="bg-primary text-white hover:bg-primary/90 rounded-full px-6">Book Session</Button>
                </Link>
              </div>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden" data-testid="mobile-menu-toggle">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4" data-testid="mobile-menu">
            <Link to="/workshop/book-journaling" className="flex items-center gap-1.5 text-accent font-semibold hover:text-accent/80 transition-colors" onClick={() => setIsOpen(false)} data-testid="nav-workshop-mobile">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
              </span>
              Happening Now!
            </Link>
            <Link to="/about" className="block text-foreground hover:text-primary transition-colors" onClick={() => setIsOpen(false)}>About</Link>
            <Link to="/services" className="block text-foreground hover:text-primary transition-colors" onClick={() => setIsOpen(false)}>Services</Link>
            <Link to="/contact" className="block text-foreground hover:text-primary transition-colors" onClick={() => setIsOpen(false)}>Contact</Link>

            {isAdmin ? (
              <>
                <Link to="/admin" className="block text-foreground hover:text-primary transition-colors" onClick={() => setIsOpen(false)}>
                  Admin
                </Link>
                <Button onClick={handleAdminLogout} variant="outline" size="sm" className="w-full">Logout</Button>
              </>
            ) : (
              <>
                <Link to="/discovery" className="block" onClick={() => setIsOpen(false)}>
                  <Button variant="outline" className="rounded-full w-full border-primary text-primary">Discovery Call</Button>
                </Link>
                <Link to="/book" className="block" onClick={() => setIsOpen(false)}>
                  <Button className="bg-primary text-white hover:bg-primary/90 rounded-full w-full">Book Session</Button>
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
